import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=224288d0&scoped=true&"
var script = {}
import style0 from "./Simple.vue?vue&type=style&index=0&id=224288d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224288d0",
  null
  
)

export default component.exports